// MP-OS-190: the one failure message for a download button (useDownload): a visible alert and a
// retry that runs the same download again, without reloading the page.
export function DownloadError({ message, onRetry, className }: {
  message: string
  onRetry: () => void
  className?: string
}) {
  return (
    <div className={className ? `download-error ${className}` : 'download-error'}
      style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', color: '#b4231f', fontSize: '0.8rem', margin: '6px 0 0' }}>
      <p role="alert" style={{ margin: 0 }}>{message}</p>
      <button type="button" onClick={onRetry}>Retry</button>
    </div>
  )
}
